/**
 * This enum represents all the potential values for items in the saved item dropdown config.
 */
export var SavedItemDropdownAction;
(function (SavedItemDropdownAction) {
    SavedItemDropdownAction["NEW_FROM_TEMPLATE"] = "newFromTemplateSavedItem";
    SavedItemDropdownAction["OPEN"] = "openSavedItem";
    SavedItemDropdownAction["SAVE"] = "saveSavedItem";
    SavedItemDropdownAction["SAVE_AS"] = "saveAsSavedItem";
    SavedItemDropdownAction["SET_AS_DEFAULT"] = "setAsDefaultSavedItem";
    SavedItemDropdownAction["RENAME"] = "renameSavedItem";
    SavedItemDropdownAction["CLOSE"] = "closeSavedItem";
    SavedItemDropdownAction["DELETE"] = "deleteSavedItem";
    SavedItemDropdownAction["COPY_STATE"] = "copyStateSavedItem";
})(SavedItemDropdownAction || (SavedItemDropdownAction = {}));
